import { Tooltip } from '@mui/material'
import { QUIET_CHECKING_TOOLTIP } from './quietStaleCheck.js'

// A decision button that waits for the quiet stale check on open
// (quietStaleCheck.js) says why: "Checking for updates…". A disabled MUI
// button gets no hover events, so the tooltip sits on a span around it, the
// same way UncheckedGate (AgentDraftLayout.jsx) does. block: for a
// full-width button.
export default function QuietCheckGate({ waiting, block = false, children }) {
  if (!waiting) return children
  return (
    <Tooltip title={QUIET_CHECKING_TOOLTIP}>
      <span style={{ display: block ? 'block' : 'inline-flex' }} data-testid="quiet-check-gate">{children}</span>
    </Tooltip>
  )
}
